import { useCallback } from 'react';
import { useAuthStore } from '@stores/authStore';

// ---------------------------------------------------------------------------
// useAuthGuard — K12 已移除登录限制，guard 始终放行。
// ---------------------------------------------------------------------------

interface UseAuthGuardOptions {
  /** 未登录时的自定义回调（K12 下不再触发） */
  onUnauthorized?: () => void;
}

interface UseAuthGuardReturn {
  isLoggedIn: boolean;
  /** 包裹动作：K12 下始终执行，不拦截 */
  guard: <T>(action: () => T) => T | undefined;
}

export function useAuthGuard(_options?: UseAuthGuardOptions): UseAuthGuardReturn {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);

  // K12: 无登录限制，直接执行操作
  const guard = useCallback(<T>(action: () => T): T | undefined => action(), []);

  return { isLoggedIn, guard };
}
